function initializeBound() {
    if (SCM.BoundingCoordinates.zoomLevel != undefined) {
        var mapOptions = {
            zoom: SCM.BoundingCoordinates.zoomLevel,
            center: new google.maps.LatLng(SCM.BoundingCoordinates.defaultLatValue, SCM.BoundingCoordinates.defaultLonValue),
            mapTypeId: SCM.BoundingCoordinates.mapTypeId,
            zoomControl: SCM.BoundingCoordinates.zoomControl,
            mapTypeControl: SCM.BoundingCoordinates.mapTypeControl,
            streetViewControl: false,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition['TOP_RIGHT']
            },
            panControlOptions: {
                position: google.maps.ControlPosition['TOP_LEFT']
            },
            ZoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition['TOP_LEFT']
            }
        };


        var map = new google.maps.Map(document.getElementById('google-bounding-map-canvas'), mapOptions);

        var eventNamespace = '.boundingCoordinates';
        var minimumDragDistanceInPixels = 5;
        var enterKeyCode = 13;
        var primaryMouseButton = 0;
        var minimumMapWidthForCenteredToolbarInPixels = 500;
        var panIconMarkup = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/></svg>';
        var drawRectangleIconMarkup = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3.5" y="5.5" width="17" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-dasharray="4 2.5"/></svg>';

        var selectedShape;
        var draftShape;
        var dragStart;
        var isDrawMode;
        var isSettingShapeBoundsFromCoordinates = false;
        var $panButton;
        var $drawButton;
        var toolbarElement;
        var toolbarPosition;
        var coords = $('.bounding-coordinates');
        var northCoord = $('#' + SCM.BoundingCoordinates.boundCordNorth);
        var eastCoord = $('#' + SCM.BoundingCoordinates.boundCordEast);
        var southCoord = $('#' + SCM.BoundingCoordinates.boundCordSouth);
        var westCoord = $('#' + SCM.BoundingCoordinates.boundCordWest);

        northCoord.val('');
        eastCoord.val('');
        southCoord.val('');
        westCoord.val('');

        function clearSelection() {
            if (selectedShape) {
                selectedShape.setEditable(false);
                selectedShape = null;
            }
        }

        function setSelection(shape) {
            clearSelection();
            selectedShape = shape;
            shape.setEditable(true);
            google.maps.event.addListener(shape, 'bounds_changed', function () {
                if (!isSettingShapeBoundsFromCoordinates) {
                    setCoordinates(shape.getBounds());
                }
            });
        }

        function deleteSelectedShape() {
            if (selectedShape) {
                selectedShape.setMap(null);
            }
        }

        function addCoordinateBoxEventListener() {
            coords.off('keyup' + eventNamespace).on('keyup' + eventNamespace, setRectangleShapeBounds);
        }

        function setRectangleShapeBounds() {
            var north;
            var east;
            var south;
            var west;

            if (!selectedShape) {
                return;
            }

            north = parseFloat(northCoord.val());
            east = parseFloat(eastCoord.val());
            south = parseFloat(southCoord.val());
            west = parseFloat(westCoord.val());

            if (isNaN(north) || isNaN(east) || isNaN(south) || isNaN(west)) {
                return;
            }

            isSettingShapeBoundsFromCoordinates = true;
            selectedShape.setBounds(new google.maps.LatLngBounds(new google.maps.LatLng(south, west), new google.maps.LatLng(north, east)));
            isSettingShapeBoundsFromCoordinates = false;
        }

        function setCoordinates(bounds) {
            var ne = bounds.getNorthEast();
            var sw = bounds.getSouthWest();
            northCoord.val(ne.lat()); // minY
            eastCoord.val(ne.lng()); // maxX
            southCoord.val(sw.lat()); // maxY
            westCoord.val(sw.lng()); // minX
        }

        function createToolbarButton(label, iconMarkup) {
            return $('<button type="button" class="bounding-coordinates-toolbar__button"></button>')
                .attr({ 'aria-label': label, title: label })
                .html(iconMarkup);
        }

        function addDrawingToolbar() {
            var $toolbar = $('<div class="bounding-coordinates-toolbar" role="group" aria-label="Map drawing tools"></div>');

            $panButton = createToolbarButton('Pan map', panIconMarkup).on('click', function () {
                setDrawMode(false);
            });
            $drawButton = createToolbarButton('Draw rectangle', drawRectangleIconMarkup).on('click', function () {
                setDrawMode(true);
            });

            $toolbar.append($panButton, $drawButton).on('keypress', keepEnterKeyFromClickingDefaultButton);
            toolbarElement = $toolbar[0];
            placeDrawingToolbar();
            $(window).off('resize' + eventNamespace).on('resize' + eventNamespace, placeDrawingToolbar);
        }

        function getDrawingToolbarPosition() {
            return map.getDiv().offsetWidth < minimumMapWidthForCenteredToolbarInPixels
                ? google.maps.ControlPosition.LEFT_TOP
                : google.maps.ControlPosition.TOP_CENTER;
        }

        function placeDrawingToolbar() {
            var position = getDrawingToolbarPosition();
            var currentControls;

            if (position === toolbarPosition) {
                return;
            }

            if (toolbarPosition !== undefined) {
                currentControls = map.controls[toolbarPosition];
                currentControls.removeAt(currentControls.getArray().indexOf(toolbarElement));
            }

            map.controls[position].push(toolbarElement);
            toolbarPosition = position;
        }

        function keepEnterKeyFromClickingDefaultButton(e) {
            if (e.which === enterKeyCode) {
                e.stopPropagation();
            }
        }

        function setDrawMode(isEnabled) {
            isDrawMode = isEnabled;
            map.setOptions({
                draggable: !isEnabled,
                draggableCursor: isEnabled ? 'crosshair' : null
            });
            $panButton.attr('aria-pressed', String(!isEnabled));
            $drawButton.attr('aria-pressed', String(isEnabled));
        }

        function startDrag(e) {
            if (isDrawMode && e.domEvent.button === primaryMouseButton) {
                dragStart = { latLng: e.latLng, x: e.domEvent.clientX, y: e.domEvent.clientY };
            }
        }

        function continueDrag(e) {
            var horizontalDistance;
            var verticalDistance;

            if (!dragStart) {
                return;
            }

            if (!e.domEvent.buttons) {
                finishDrag();
                return;
            }

            horizontalDistance = e.domEvent.clientX - dragStart.x;
            verticalDistance = e.domEvent.clientY - dragStart.y;

            if (!draftShape) {
                if (Math.abs(horizontalDistance) < minimumDragDistanceInPixels && Math.abs(verticalDistance) < minimumDragDistanceInPixels) {
                    return;
                }
                draftShape = new google.maps.Rectangle({ map: map, clickable: false });
            }

            draftShape.setBounds(getDragBounds(e.latLng, horizontalDistance >= 0));
        }

        function getDragBounds(dragEnd, isDraggingEast) {
            var start = dragStart.latLng;
            var west = isDraggingEast ? start.lng() : dragEnd.lng();
            var east = isDraggingEast ? dragEnd.lng() : start.lng();
            var south = Math.min(start.lat(), dragEnd.lat());
            var north = Math.max(start.lat(), dragEnd.lat());

            return new google.maps.LatLngBounds(new google.maps.LatLng(south, west), new google.maps.LatLng(north, east));
        }

        function finishDrag() {
            dragStart = null;

            if (!draftShape) {
                return;
            }

            deleteSelectedShape();
            setSelection(draftShape);
            setCoordinates(draftShape.getBounds());
            draftShape = null;
        }

        function addDrawingEventListeners() {
            google.maps.event.addListener(map, 'mousedown', startDrag);
            google.maps.event.addListener(map, 'mousemove', continueDrag);
            $(document).off('mouseup' + eventNamespace).on('mouseup' + eventNamespace, finishDrag);
        }

        addCoordinateBoxEventListener();

        addDrawingToolbar();
        setDrawMode(true);
        addDrawingEventListeners();
    }
}

var SCM = SCM || {};

(function (ns, $, undefined) {
    ns.loadBoundCoordScript = function () {
        initializeBound();
    };

})(SCM.BoundingCoordinates = SCM.BoundingCoordinates || {}, jQuery);